//removeIf(production)
import TopGasAlert from "../../enums/top-gas-alert";
//removeIf(production)
import FloatWithTwoDecimals from "./float-with-two-decimals";
//endRemoveIf(production)

class ClaroluzTopGas {
    public hasTopGas: boolean;
    public hasAlert: boolean;
    public alert: TopGasAlert | undefined;
    public value: number;
    public offerValue: number;

    constructor({ hasTopGas, value, offerValue, hasAlert, alert }: { hasTopGas: boolean; value: number; offerValue: number; hasAlert?: boolean; alert?: TopGasAlert; }) {
        this.hasTopGas = hasTopGas;
        this.hasAlert = hasAlert ?? false;
        this.value = new FloatWithTwoDecimals(value).value;
        this.offerValue = new FloatWithTwoDecimals(offerValue).value;

        if (this.hasAlert) {
            if (typeof alert !== 'number') {
                throw new Error("Alert message is required");
            }

            this.alert = alert;
        }
    }
}

//removeIf(production)
export default ClaroluzTopGas;
//endRemoveIf(production)